import React, { createContext } from 'react';
export type FeatureFlagResponseT = {
  enabled: boolean;
} | {
  error: string;
};
export type GetFeatureFlagFunctionT = (featureName: string) => Promise<FeatureFlagResponseT>;
type PropsT = {
  getFeatureFlag: GetFeatureFlagFunctionT;
  children: React.ReactNode;
};
type FeatureFlagT = {
  getFeatureFlag: (featureName: string) => Promise<FeatureFlagResponseT>;
};
export const FeatureFlagContext = createContext<FeatureFlagT>({
  getFeatureFlag: async () => ({
    enabled: false
  })
});
export const FeatureFlagProvider = ({
  getFeatureFlag,
  children
}: PropsT) => {
  return <FeatureFlagContext.Provider value={{
    getFeatureFlag
  }}>{children}</FeatureFlagContext.Provider>;
};
export type ULabelConfigResponseT = {
  userUUIDs: string[];
  userEmails: string[];
} | {
  firstWarning: {
    lookbackTasks: number;
    percentBelowMinThreshold: number;
  };
  // this will be utilised in future iterations
  furtherWarnings: {
    lookbackTasks: number;
    percentBelowMinThreshold: number;
  };
} | number | {
  items: string[];
} | null;
export type GetULabelConfigFunction = (featureName: string) => ULabelConfigResponseT;